import { useSelector } from 'react-redux';
import '../css/app.css';
import '../css/main.css';
import '../css/common.css';
import '../css/payment.css';
import { useMemo } from 'react';
import { useLocation, useNavigate, useMatch } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBagShopping } from '@fortawesome/free-solid-svg-icons';

function Header() {
    const location = useLocation();
    const navigate = useNavigate();

    // 모든 훅은 무조건 호출 (rules-of-hooks 준수)
    const midFromStore = useSelector((s) => s.login?.mid);
    const midFromPath = useMemo(() => {
        const seg = location.pathname.split('/').filter(Boolean)[0] || '';
        return /^[A-Za-z0-9._-]+$/.test(seg) ? seg : '';
    }, [location.pathname]);
    const mid = midFromStore || midFromPath;

    const hideHeader = location.pathname === '/urlNotice';
    const isMidRoot = !!useMatch('/:mid');

    if (hideHeader) return null;

    const goBack = () => navigate(-1);
    const goHome = () => (mid ? navigate(`/${mid}`) : navigate('/urlNotice'));
    const goCart = () => (mid ? navigate(`/${mid}/history`) : navigate('/urlNotice'));

    return (
        <header
            className="urlHeader-bar"
            role="banner"
            style={{ gridTemplateColumns: '40px 1fr 56px' }}
        >
            <button
                type="button"
                className="urlHeader-btn urlHeader-back"
                aria-label="뒤로가기"
                onClick={goBack}
            >
                <ArrowLeft />
            </button>

            <img
                src="/img/logo.PNG"
                alt="logo"
                style={{ height: 28, cursor: 'pointer' }}
                onClick={goHome}
            />

            <button
                type="button"
                className="urlHeader-btn urlHeader-cart"
                aria-label="장바구니"
                onClick={goCart}
                disabled={!mid}
                title={mid ? '구매내역' : '가맹점 미확인'}
            >
                <FontAwesomeIcon icon={faBagShopping} className="urlHeader-ico" />
            </button>
        </header>
    );
}

export default Header;
